export default "__VITE_ASSET__e586dffb__"